import './Reports.scss'

import React, {Component} from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import Table from 'common/views/atoms/Table/Table'
import moment from 'moment-timezone'
import { selectIsTransitionBroker } from 'broker/selectors/auth'

class Reports extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    const { props } = this

    const ReportLink  = (item) => {
        if (item.status === "Ready to download") {
          return <a href={item.link}><strong>{ item.report_name }</strong></a>
        }
        return <strong>{ item.report_name }</strong>
    }

    const renderItem = (item) => {
      const createdAt = moment.utc(item.created_at).local().format("MM-DD-YY h:mm A")

      return <tr key={ item.id }>
        <td>
          <div>
            <div className="Reports__name">
              {ReportLink(item)}
            </div>
          </div>
        </td>
        <td>
          <div>
            <div className="Reports__status">
              <div>{ item.status }</div>
            </div>
          </div>
        </td>
        <td>
          <div>
            <div className="Reports__created-at">
              <div>{ createdAt }</div>
            </div>
          </div>
        </td>
      </tr>
    }

    function renderSection(items) {

      return (
        <div key={"reports"}>
          <Table>
            <thead>
              <tr>
                <th>Report Name</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
            { items && items.length !== 0 ? items.map(renderItem): null}
            </tbody>
          </Table>
        </div>
      )
    }

    return (
      <div>
        <ReactTooltip/>
        <div className="Reports">
          <h2 className="Reports__header">Reports</h2>
          { props.account.reports ? renderSection(props.account.reports) : <div className="Reports__loading pulse"/> }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isTransitionBroker: selectIsTransitionBroker(state)
})

export default connect(mapStateToProps)(Reports)
